import { assetType } from "../../../constant";


const assetReducer = (state = false, action) => {
    switch (action.type) {
        case assetType.ADD_ASSET:
            return action.payload;
        default:
            return state;
    }
}
export default assetReducer